export default __webpack_public_path__ + "static/media/userVideo.d1be9c4e.svg";